<template>
    <scroll-area>
      <template slot="body">
        <v-container v-if="getSelected" fluid fill-height ma-0 pa-0>
          <v-layout pa-0 ma-0>
            <v-flex xs4  style="min-width: 400px">
              <v-layout fill-height column >
                <v-layout column fill-height justify-start pl-3>
                  <v-layout shrink  justify-space-between >
                    <v-btn :data-testid="$options.name + 'v-btn' + 'onSideChange'" @click="onSideChange" small color="grey lighten-2">
                      {{$t(getSide)}}
                    </v-btn>
                  </v-layout>
                  <v-flex shrink pl-2 style="max-height: 300px;">
                    <component
                      is="device-card"
                      :data="getSelected"
                      :side="getSide"
                      :editable="false"
                      />
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>

            <v-flex xs8  pl-1>
              <v-layout column fill-height justify-start >
                <v-layout column >
                  <component
                    is="show-fields"
                    :data="getSelected"
                    :current="getCurrent"
                    :editable="false"
                    @status="(payload) => {this.$emit('status', payload)}"
                  />

                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </scroll-area>
</template>

<script lang="ts">
import Vue from 'vue'
import DeviceCard from '@/nms/components/device/device-card.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import ShowFields from '@/nms/pages/device/form/show-device-bar-fields'

// Типы для данных
interface EquipmentData {
  [key: string]: any
}

interface CurrentState {
  side: string
  template: any | null
  parent: any | null
}

interface SelectedEquipment {
  [key: string]: any
}

export default Vue.extend({
  name: 'EQUIPMENT_INFORMATION',

  components: {
    scrollArea,
    DeviceCard,
    ShowFields,
  },

  props: {
    data: {
      type: Object as () => EquipmentData,
      default: () => ({})
    },
  },

  data(): {
    current: CurrentState
  } {
    return {
      current: {
        side: 'front',
        template: null,
        parent: null
      }
    }
  },

  computed: {
    getCurrent(): CurrentState {
      return this.current
    },

    getSide(): string {
      return this.current.side
    },

    getSelected(): SelectedEquipment {
      return this.$store.state.equipment.selectedEquipment
    },
  },

  methods: {
    setup(): void {},

    onSideChange(): void {
      const s = this.current.side
      this.current.side = s === 'front' ? 'rear' : 'front'
    },
  },
})
</script>

<style lang="css" scoped>
</style>
